(function () {
    'use strict';

    var module = angular.module('uwAgenda.email');
    module.directive('emailTableRow', ['EmailService', 'Alert', '$uibModal', 'Email', 'SharedAgendaService', EmailTableRowFn]);

    function EmailTableRowFn(EmailService, Alert, $uibModal, Email, SharedAgendaService) {

        var directive = {
            link: link,
            restrict: 'A',
            replace: true,
            templateUrl: '/app/email/overview/templates/email-table-row.template.html'
        };
        return directive;

        function link(scope) {
            // set itemTableService
            var itemTableService = scope.vm.overview;

            // show mail
            scope.show = function () {
                // open modal
                EmailService.show(scope.item.id);
            };

            // forward mail
            scope.forward = function () {
                // load email and open modal to forward 
                EmailService.preview(scope.item.id).then(function (result) {
                    var email = new Email();
                    email.extend(result);
                    // delete to and bcc 
                    email.contactInfo = null;
                    email.contactInfoBCC = null;
                    email.prepareView();

                    // write
                    var modalInstance = EmailService.write(email);
                    // when modal is closed
                    modalInstance.result.then(function (item) {
                        var email = new Email();
                        email.extend(item);
                        itemTableService.put(email, true); // to beginning

                    }, function () {
                        //dismissed
                    });
                });
            };


            // deactivate item (remove from table if it is new)
            scope.deactivate = function () {
                EmailService.deactivate(scope.item.id).then(function (result) {
                    Alert.success(result);
                    // remove from list
                    itemTableService.remove(scope.item.vmIndex);
                });
            };
        }
    }
})();